module.exports = __webpack_public_path__ + "static/image-01-a@2x-3ff2a502ac5efa67e7cd320cbfff3105.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/image-01-a@2x.jpg
// module id = 434
// module chunks = 3627797113349 20562973939449 33019919093843